import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
import axios from 'axios';
import config from '../config';

const RSA_PUBLIC_KEY = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCOtuo6AdTt8kGLTaGeByOZjuVKxfMzqrUBeYNAdVgCbDwBY9ef9m6Z+EYxu6AYETrExc9XxZdqIOXlpexaTtbGBOw/ER4953vELSz4bTAg8iO0YbU8PM9cIM+TFbes43l7zXvugAEISro9wGzFD9jYaQoEWex7Cuvr/58LWOkNUQIDAQAB";
/**
 * 生成随机字符串
 * @param {number} num - 长度
 * @returns {string} 随机字符串
 */
function randomString(num) {
  let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  let nums = "";
  for (var i = 0; i < num; i++) {
    var id = parseInt(Math.random() * 61);
    nums += chars[id];
  }
  return nums;
}

/**
 * 生成Auth加密字符串
 * @param {string} str - 原始字符串
 * @returns {string} 加密后的字符串
 */
function getAuthString(str) {
  let Encrypted_str = ['y','t','k','2'];
  let Encrypted_pos = [9,5,2,7];
  let arr = str.split("");
  // 在指定位置插入字符
  arr[Encrypted_pos[0]] = Encrypted_str[0];
  arr[Encrypted_pos[1]] = Encrypted_str[1];
  arr[Encrypted_pos[2]] = Encrypted_str[2];
  arr[Encrypted_pos[3]] = Encrypted_str[3];
  // 转换回字符串
  let newStr = arr.join("");
  return newStr;
}

/**
 * 生成Auth参数
 * @returns {string} 加密后的Auth字符串
 */
function generateAuth() {
  // 生成随机字符串
  const randomStr = randomString(16);

  // 加密
  return getAuthString(randomStr);
}

/**
 * 获取服务器时间戳
 * @returns {Promise<number>} 服务器时间戳（秒）
 */
async function getServerTimestamp() {
  try {
    // 生成Auth参数
    const auth = generateAuth();
    const apiRoot = config.getApiRootSync();
    const fullUrl = `${apiRoot}/Time/GetTimeStamp`;
    const response = await axios.get(fullUrl, {
      params: { Auth: auth },
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.data && response.data.code === 0 && response.data.data) {
      // 固定的AES Key和IV
      const AESKey = '7K9s2P8dG5zQ1xR7vB4nM6cF2gH9jK5l';
      const AESIV = '3pO7sD2kF9gH5jL1';
      // 解密时间戳
      const decryptedTimestamp = aesDecrypt(response.data.data, AESKey, AESIV);
      return Number(decryptedTimestamp);
    }
    throw new Error('获取服务器时间戳失败');
  } catch (error) {
    console.error('获取服务器时间戳失败，使用本地时间');
    console.error('错误详情:', error);
    console.error('错误消息:', error.message);
    console.error('错误响应:', error.response);
    // 失败时使用本地时间
    return Math.floor(Date.now() / 1000);
  }
}

/**
 * 生成 32 位 AES 密钥
 * @returns {string} 32位随机密钥
 */
function generateAESKey() {
  return randomString(32);
}

/**
 * 生成 16 位 AES IV
 * @returns {string} 16位随机IV
 */
function generateAESIV() {
  return randomString(16);
}

/**
 * AES 加密
 * @param {string} data - 要加密的数据
 * @param {string} key - AES密钥
 * @param {string} iv - AES IV
 * @returns {string} 加密后的字符串
 */
function aesEncrypt(data, key, iv) {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const ivHex = CryptoJS.enc.Utf8.parse(iv);
  const encrypted = CryptoJS.AES.encrypt(data, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

/**
 * AES 解密
 * @param {string} encryptedData - 加密的数据
 * @param {string} key - AES密钥
 * @param {string} iv - AES IV
 * @returns {string} 解密后的字符串
 */
function aesDecrypt(encryptedData, key, iv) {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const ivHex = CryptoJS.enc.Utf8.parse(iv);
  const decrypted = CryptoJS.AES.decrypt(encryptedData, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * RSA 加密
 * @param {string} data - 要加密的数据
 * @returns {string} 加密后的字符串
 */
function rsaEncrypt(data) {
  const decodedKey = RSA_PUBLIC_KEY;
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(decodedKey);
  return encrypt.encrypt(data);
}
` `
/**
 * 生成加密请求参数
 * @param {object} params - 原始参数
 * @param {string} publicKey - RSA公钥
 * @returns {Promise<object>} 加密后的参数 { sign, content }
 */

async function encryptRequest(params) {
  // 1. 获取服务器时间戳
  const timestamp = await getServerTimestamp();

  // 2. 生成随机 32 位 AES 密钥和 16 位 AES IV
  const aesKey = generateAESKey();
  const aesIV = generateAESIV();

  // 3. 拼接：aesKey|aesIV|timestamp
  const signData = `${aesKey}|${aesIV}|${timestamp}`;

  // 4. 用 RSA 公钥加密 aesKey|aesIV|timestamp → sign
  const sign = rsaEncrypt(signData);

  // 5. 求参 → content（用 AES 加密原始参数）
  const content = aesEncrypt(JSON.stringify(params), aesKey, aesIV);

  // 6. 返回加密后的参数
  return {
    sign,
    content
  };
}

export default {
  randomString,
  getAuthString,
  generateAuth,
  getServerTimestamp,
  generateAESKey,
  generateAESIV,
  aesEncrypt,
  aesDecrypt,
  rsaEncrypt,
  encryptRequest
};



// WEBPACK FOOTER //
// ./src/service/crypto.js